import { v4 as uuidv4 } from 'uuid';
// generate static id per 'browser page' / application instance.
export default uuidv4();
